import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./App.css";

const checklistItems = [
  "-8591900330462080048",
  "923372438967185305",
  "-1940305225479694039",
  "9058007704254504711",
  "6344678308688416548",
  "2310336522001542127",
  "1583633504332031118",
  "4366854889944202123",
  "-5130068645031981276",
  "-587555058467579841",
  "-6412036905525137135",
  "3375320420129844992",
  "-6432548771407811278",
  "923372704738253854",
  "-2032795982907864146",
  "923372718574544870",
  "3646877311918653279",
  "923372315595880659",
  "-5243117998460173251",
  "-3604785108058402050",
  "6061340180966156609",
  "-7892501756807350876",
  "8873471223206785374",
  "2382452357178999227",
  "335231559228961104",
  "1977649108",
  "55147718797313",
  "-4214219318972524774",
  "-3556402759935773199",
  "1601064389637127331",
];

function App() {
  const [checkedItems, setCheckedItems] = useState(
    () => JSON.parse(localStorage.getItem("checkedItems")) || new Array(checklistItems.length).fill(false)
  );

  useEffect(() => {
    localStorage.setItem("checkedItems", JSON.stringify(checkedItems));
  }, [checkedItems]);

  const handleCheckboxChange = (index) => {
    const newCheckedItems = [...checkedItems];
    newCheckedItems[index] = !newCheckedItems[index];
    setCheckedItems(newCheckedItems);
  };

  const completedCount = checkedItems.filter(Boolean).length;
  const progressPercentage = (completedCount / checklistItems.length) * 100;

  const sortedChecklistItems = checklistItems
    .map((item, index) => ({ item, checked: checkedItems[index], originalIndex: index }))
    .sort((a, b) => a.checked - b.checked);

  const containerStyle = {};

  return (
    <div className="container" style={containerStyle}>
      <h1 className="heading">Seed Checklist</h1>
      <div className="card">
        <div className="progress-container">
          <div
            className="progress-bar"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
        <p>
          {completedCount}/{checklistItems.length} Seeds Explored
        </p>
        <div className="checklist">
          <AnimatePresence>
            {sortedChecklistItems.map(({ item, checked, originalIndex }) => (
              <motion.label
                key={item}
                className={`checkbox-container ${checked ? "checked" : ""}`}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                layout
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => handleCheckboxChange(originalIndex)}
                />
                {item}
              </motion.label>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default App;